var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LLSpoilerWrapper"},[_c('button',{staticClass:"LLSpoilerWrapper__toggler",attrs:{"disabled":_vm.disabled},on:{"click":_vm.clickEvent}},[_vm._t("toggler",null,{"expanded":_vm.localExpanded})],2),(_vm.localExpanded)?_vm._t("content"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }